var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactEmail = function SvgContactEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.336,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5090",
    transform: "translate(-907 -894)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0eb948",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.55 901.154h12.4a1.553 1.553 0 0 1 1.55 1.547v9.285a1.553 1.553 0 0 1-1.55 1.547h-12.4a1.553 1.553 0 0 1-1.55-1.547v-9.285a1.553 1.553 0 0 1 1.55-1.547",
    "data-name": "Path 18718"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m927.5 902.701-7.75 5.416-7.75-5.416",
    "data-name": "Path 18719"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#22cb5b",
    "data-name": "Ellipse 357",
    opacity: 0.1,
    transform: "translate(907 894)"
  }))));
};
export default SvgContactEmail;